module.exports = __webpack_public_path__ + "static/media/SpenLeaf-3.ecd8bf7b.webp";